import React, { useState, useEffect} from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import jwt_decode from 'jwt-decode';
import "../assets/css/styles.table.css"
import Sidebar from './Sidebar';
import Header from './Header';
import Layout from './Layout';
import Box from '@mui/material/Box';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import {apiUrl, apiUrl2} from './UrlParam'; 
import AxiosFetchData from './AxiosFetchData';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import poHeader from '../assets/img/po/header.gif';
import poSign from '../assets/img/po/apv-sign.gif';
import poFooter from '../assets/img/po/footer.gif';
import {Modal, Typography} from '@mui/material';
import angkaTerbilang from '@develoka/angka-terbilang-js';
import   {FetchData}    from './FetchData.js';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DeleteIcon from '@mui/icons-material/Delete';
import Helper from './Helper';
 
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import ConfirmationButton from '../components/ConfirmationButton.js';
import MainPrint from './MainPrint.js';
import DynamicDataGridComponent from  '../components/DynamicDataGrid.js';

const Material = () => {
  const { id } = useParams();
  const [name, setName] = useState('');
  const [token, setToken] = useState('');
  const [expire, setExpire] = useState('');
  const Navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [rowNumber, setRowNumber] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [print, setPrint] = useState(false);
  const [productList, setProductList] = useState([]);
  const [note, setNote] = useState('');
  const [content, setContent] = useState('');
  const [dataInvoice, setDataInvoice] = useState({});
  const [html, setHtml] = useState('');
  const [total, setTotal] = useState(0);
  const [customer, setCustomer] = useState([]);
  const [tipe, setTipe] = useState('');
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedData, setSelectedData] = React.useState({});
  const open = Boolean(anchorEl);
  const [message, setmessage] = useState('');
  const [openRetention, setOpenRetention] = React.useState(false);
  const [selectedOptionPeriod, setSelectedOptionPeriod] = useState({});
  const [period, setPeriod] = useState('');
  const [retensi, setRetensi] = useState(0);
  const [periodNumber, setPeriodNumber] = useState(0);
  const [isNullRetention, setIsNullRetention] = useState(false);

  const handleClick = (event,data) => {
    console.log(data)
    setSelectedData(data)
    setAnchorEl(event.currentTarget)
    console.log(selectedData)
    console.log(anchorEl)
    // setSelectedData(data)
    // setAnchorEl(event.currentTarget);
    //alert(open)
  };

  const handleClose = () => {
    setAnchorEl(null);
  };


  var result = "";
 
  var mainPrint = new MainPrint(id);

  useEffect(() => {
     
    fetchData();
  
  }, []); // Add token as a dependency if it's required
  
  const GetRetention = async function () {
    try {
      const response = await AxiosFetchData.get(`GetRetention/${id}`).refreshToken(Navigate);
      return response;
    } catch (error) {
      setmessage(error.message);
    }

  }

  const fetchData =  async () => {
    try {
 
       const response = await axios.get(`${apiUrl2}/api/getRequestMaterialManagement`) 
       
       if(response){
          setRows(response.data); // Update rows with project data

          // Add row numbers to the rows
          const rowsWithRowNumbers = response.data.map((row, index) => ({
            ...row,
            rowNumber: index + 1, 
            
          }));
          setRows(rowsWithRowNumbers);

         
       }
    
    } catch (error) {
      setmessage(error.message);
      //console.error('Error fetching project data:', error.message);
    }
  };
 
const columns = [
  { field: 'rowNumber', headerName: 'No.', width: 80 },
  { field: 'req_no', headerName: 'Request Code', width: 210 },
  { field: 'req_date', headerName: 'Reg Date', width: 100 },
  { field: 'req_date_ready', headerName: 'Ready Date', width: 100 },
   
  {
    field: 'actions',
    headerName: 'Actions',
    width: 180,
    renderCell: (params) => (
      <>
      <Button
        id={"basic-button" + params.row.rowNumber}
        aria-controls={open ? 'basic-menu' + params.row.rowNumber : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
       
        onClick={(evt) => {
        
          handleClick(evt, params.row)
        }}
      >
        <MoreVertIcon sx={{ fontSize: 30 }}/>
      </Button>
 
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem    onClick={() => handleEdit(selectedData.rmid)} >EDIT{Boolean(anchorEl)}</MenuItem>
        {/* <MenuItem    onClick={() => handlePrintInvoice(selectedData.id)} >PRINT INVOICE</MenuItem>
        <MenuItem    onClick={() => handlePrintKwitansi(selectedData.id)} >PRINT KWINTASI</MenuItem> */}
      </Menu>
     
 
      <ConfirmationButton classname='btn btn-danger' text="Do you want delete this data?" type="button"  title="Delete"      onClick={() => handleDelete(params.row.rmid)} >
        <DeleteIcon sx={{ fontSize: 15 }}/> Delete   
           </ConfirmationButton>
      </>
      
    ),

  },
];
 

const [filterModel, setFilterModel] = React.useState({
  items: [],
  quickFilterExcludeHiddenColumns: true,
  quickFilterValues: [''],
});

const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({});
// end table

function AddProjectData() {

  Navigate(`/MaterialDetail/${id}/0${Helper.SetReturnUrl()}`);

}

const handleDelete = async (projectId) => {
 
  try {
    var data =[{
        rmid:projectId,
    }]

    var data2 =[{
        rdid:projectId,
    }]
    var response = await axios.post(`${apiUrl2}/api/deleteRequestMaterialManagementMaster`, data) 
    response = await axios.post(`${apiUrl2}/api/deleteRequestMaterialManagementDetail`, data2) 

    if(response){
      await fetchData();
      setmessage("Data deleted successfully")
    }
    
  } catch (error) {
      setmessage(error.message)
    //console.error('Error deleting project:', error);
  }
//}
};


const handleEdit = (projectId) => {

  Navigate(`/MaterialDetail/${id}/${projectId}${Helper.SetReturnUrl()}`);
};
 
  const openPopupAndPrintPo = (data) => {
     
    var popup = window.open('', 'PRINT', 'height=400,width=400');
    if
    (tipe=="invoice"){
        popup.document.write(mainPrint.printInvoice(html, customer, dataInvoice).replace('position: relative','position: fixed').replace('</header><br><br>','</header><br><br><br><br><br><br>'));
    }else{
        popup.document.write(mainPrint.printKwitansi(html, customer, dataInvoice).replace('position: relative','position: fixed').replace('</header><br><br>','</header><br><br><br><br><br><br>'));
  
    }
   
    popup.print(); 
   // popup.close();
    let element = document.getElementById('modalcontent');
    element.innerHTML =  mainPrint.printInvoice(html, customer, dataInvoice);
   // setContent({__html: popupContent(data)});
     
  }

     

  async function handleRetentionClose(event, reason){
    if(rows.length == 0){
      if(reason !== "backdropClick"){
        setOpenRetention(false);
      }
    }else{
      setOpenRetention(false);
    }
  }

  async function handleSaveRetention(event){
    event.preventDefault();
    //setOpenRetention(false);
    setIsNullRetention(false)
    const formData = new FormData(event.currentTarget);
    const formJson = Object.fromEntries(formData.entries());
    
    var data = {
              project_id : id,
              retensi : formJson.txtRtn,
              period_number :  formJson.txtPeriod,
              period : formJson.optPeriod,
              isDelete : 0
            }
            //alert(email);
    try{
          var response = await AxiosFetchData.post(`UpdateRetention`, data).refreshToken(Navigate)
          setmessage(response.data);
          await fetchData();
        }catch(e){
          setmessage(e.message);
        }
           
        handleRetentionClose();
}

  return (
    <>
       
    <Layout message={message} setmessage={setmessage}>
  <div className='pd'><b>MATERIAL LIST</b> 
  
  </div>
 
  <div className="pd">
  
    <div style={{position:'relative'}}>
       <div style={{marginBottom:15}}><button className='btn btn-success' onClick={AddProjectData}>Add Material</button></div>
       <div style={{position:'absolute', right:0,top:0, display:'none'}}>
       <button className='btn btn-primary' onClick={async () => {
           // const response = await AxiosFetchData.get(`GetRetention/${id}`).refreshToken(Navigate);
            const response = await GetRetention();
           // console.log(response)
            if(response.data){
              setRetensi(response.data.retensi)
              setPeriodNumber(response.data.period_number)
              setPeriod(response.data.period)
            }
            setOpenRetention(true)
        }}>Retention</button>
       <Dialog
        open={openRetention}
        onClose={handleRetentionClose}
        height={450}
        // PaperProps={{
        //   component: 'form',
        //   onSubmit: async (event) => {
        //     event.preventDefault();
        //     const formData = new FormData(event.currentTarget);
        //     const formJson = Object.fromEntries(formData.entries());
        //     alert(formJson.txtRtn)
        //     var data = {
        //       project_id : id,
        //       retensi : formJson.txtRtn,
        //       period_number :  formJson.txtPeriod,
        //       period : formJson.optPeriod,
        //       isDelete : 0
        //     }
        //     //alert(email);
        //     try{
        //         var response = await AxiosFetchData.post(`UpdateRetention`, data).refreshToken(Navigate)
        //         setmessage(response.data);
        //     }catch(e){
        //       setmessage(e.message);
        //     }
           
        //     handleRetentionClose();
        //   },
        // }}
      >
        
        <form id="formRetention" onSubmit={handleSaveRetention} >
        <DialogContent>
          <DialogContentText>
          <h4>RETENTION</h4><br></br>
          {isNullRetention && (
             <span style={{fontSize:12}}>You must fill in the retention before continue</span>
          )}
         
            <hr></hr>
          </DialogContentText>
         
           <FormControl sx={{ m: 1}} size="small" > 
          
              <div className='form-group row'>
                <label class="col-sm-4">Retention</label>
                <div class="col-sm-4">
                  <input
                              type="number"
                              className="form-control"
                              placeholder="Retention"
                              value={retensi}
                              onChange={(e) => setRetensi(e.target.value) }
                              name="txtRtn"
                              min={0}
                              required
                             
                             // onChange={(e) => handleText(e.target.value, index)}
                            />
              </div>
              <label >%</label>
            </div>
            <div className='form-group row'>
              <label  class="col-sm-4">Time Period</label>
              <div class="col-sm-4">
<               input
                              type="number"
                              className="form-control"
                              placeholder="Retention"
                              value={periodNumber}
                              onChange={(e) => setPeriodNumber(e.target.value) }
                              name="txtPeriod"
                              min={0}
                              required
                             
                         
                            />
              </div>
              <div class="col-sm-4">
           
              <Select
                value={period}
                onChange={(event)=> setPeriod(event.target.value)}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                required
                name="optPeriod"
              >
                 <MenuItem value="">
            <em>None</em>
              </MenuItem>
                <MenuItem value={"YEAR"}>Year</MenuItem>
                <MenuItem value={"MONTH"}>Month</MenuItem>
                <MenuItem value={"WEEK"}>Week</MenuItem>
                <MenuItem value={"DAY"}>Day</MenuItem>
              </Select>
            
          </div>  
          </div>    
          
           </FormControl>       
           <hr></hr>
        </DialogContent>
        <DialogActions>
          <button className='btn btn-danger' onClick={() => handleRetentionClose()} type="button" disabled={isNullRetention} >CANCEL</button>
          {/* <button className='btn btn-primary' type="submit">SAVE1</button>   */}
          <ConfirmationButton classname='btn btn-primary' text="Do you want save this data?" type="submit"  title="Save"  formid="formRetention" id="btnSubmit" >
               SAVE    
           </ConfirmationButton>
        </DialogActions>
        </form>    
      </Dialog>
       </div>
    </div>
   
  <Box sx={{ width: 1 }} >
      
      <Box sx={{ height: 550 }} >
        <DynamicDataGridComponent customcolumns={columns} rows={rows} name={"materialgrid"} rowid={"rmid"}>
           
        </DynamicDataGridComponent>
        {/* <DataGrid className='fonty'
          columns={columns}
          rows={rows}
          disableColumnFilter
          disableColumnSelector
          disableDensitySelector
          slots={{ toolbar: GridToolbar }}
          filterModel={filterModel}
          onFilterModelChange={(newModel) => setFilterModel(newModel)}
          slotProps={{ toolbar: { showQuickFilter: true } }}
          columnVisibilityModel={columnVisibilityModel}
          onColumnVisibilityModelChange={(newModel) =>
            setColumnVisibilityModel(newModel)
          }
          getRowId={(row) => row.rmid}
        /> */}
      </Box>
    </Box>
    </div>
 
  <Modal
        open={print}
        onClose={() => setPrint(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        id="satu"
      >
        <Box className='modals' >
        <div id="testId" className="test"> 
          <Typography id="modal-modal-title" variant="h6" component="h2">
            <div id="modalcontent" dangerouslySetInnerHTML={content}>
              
            </div>
           
          </Typography>
          <Typography id="modal-modal-description">
          <button
              onClick={() => openPopupAndPrintPo(result)}
              className='close-button'
            >
              Print
            </button>
            &nbsp;
            <button
              onClick={() => setPrint(false)}
              className='close-button'
            >
              Close
            </button>
          </Typography>
          </div>
        </Box>
        </Modal>
 
        </Layout>

    </>
  );
};

export default Material;